<template>
       <!-- Content Header (Page header) -->
       <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-3">
              <h1 class="m-0"><router-link to="/notacredito"><i class="fas fa-caret-square-left text-secondary"></i></router-link> Crear Nota Crédito</h1>
            </div>
            <div class="col-sm-3">
                <div class="input-group mb-4" v-on:keyup.enter="buscarNC()">
                    <input type="text" v-model="serieBuscar" class="form-control form-control-md" placeholder="Serie" style="text-transform: uppercase;">
                  <input type="number" v-model="numeroBuscar" class="form-control form-control-md" placeholder="Número">
              <div class="input-group-append">
                  <button type="submit" class="btn  btn-info" @click="buscarNC()">
                      <i class="fa fa-search"></i> Buscar
                  </button>
              </div>
              <div class="input-group-append">
                <button class="btn btn-secondary btn-block" @click="limpiarTodo()">Limpiar</button>
                  </div>
              </div>
              </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
                <li class="breadcrumb-item active">Crear Nota crédito</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->
    
      <div class="card card-primary card-outline">
          <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="staticEmail" class="col-form-label">Comprobante a anular</label>
                        <input type="text" class="form-control" readonly :value="comprobante">
                      </div>
                      <div class="form-group">
                        <label  class="col-form-label">Número de comprobante</label>
                          <input type="text" class="form-control" readonly :value="serieNumero">
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Cliente</label>
                          <input type="text" class="form-control" readonly :value="cliente">
                      </div>                    
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="staticEmail" class="col-form-label">Tipo de Nota de Crédito</label>
                          <select name="" class="form-control" v-model="tipoNota">
                            <option value="0">==== Seleccione ====</option>
                            <option v-for="not in arrayCodigoNC" :key="not.id" :value="not.id">{{not.descripcion}}</option>
                          </select>
                      </div>
                      <div class="form-group">
                        <label  class="col-form-label">Fecha de emisión</label>
                          <input type="date" class="form-control bg-white" :value="fechaHoy" readonly>
                      </div>
                      <div class="form-group">
                        <label  class="col-form-label">Motivo de la anulación</label>
                          <input type="text" class="form-control" v-model="motivo" placeholder="Describe el motivo" style="text-transform: uppercase;">
                      </div>
                </div>
            
              </div>
              <br>
              <div class="table-responsive">
                <table class="table table-sm table-striped table-bordered">
                    <thead class="bg-secondary">
                        <tr>
                            <th>Producto</th>
                            <th>U/M Venta</th>
                            <th>Cantidad</th>
                            <th>Precio Uni</th>
                            <th>Descuento %</th>
                            <th class="text-right">Importe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="de in arrayDetalle" :key="de.id" class="bg-warning">
                            <td>{{ de.producto }}</td>
                            <td>{{ de.umVenta }}</td>
                            <td>{{ de.cantidad }}</td>
                            <td>{{ de.precio }}</td>
                            <td>{{ de.descuento }} %</td>
                            <td class="text-right">{{ formattedTotal(de.importe) }}</td>
                        </tr>
                    </tbody>
                    <tfoot class="">
                        <tr>
                            <td colspan="3"></td>
                            <th>Subtotal: {{subtotal}}</th>
                            <th>IGV: {{igv}}</th>
                            <th class="text-right">IMPORTE TOTAL: <h3>{{formattedTotal(Number(subtotal) + Number(igv))}}</h3></th>
                        </tr>
                    </tfoot>
                
                </table>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group" style="text-align: center;">
                            <button class="btn" :class="subtotal>0?'bg-danger':'bg-secondary'" @click="grabarNota()"> GENERAR NOTA DE CREDITO</button>
                        </div>
                    </div>
                </div>
         
              </div>
          </div>
            <!-- Loading Overlay -->
            <div v-if="loading" class="loading-overlay">
                <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
                <span class="sr-only">Grabando...</span>
                </div>
                <p class="text-light mt-3">Procesando nota de credito, espere...</p>
            </div>
      </div><!-- /.card -->
</template>
<script>
    import { ref, onMounted } from 'vue' //sobre fechas
    import { DateTime } from 'luxon' //timezone manejo
    export default{
        
        setup() {
        const fechaHoy = ref('');
        onMounted(() => {
          const today = DateTime.now().setZone('America/Lima');
          fechaHoy.value = today.toISODate();
        });
        return {
          fechaHoy,
        };
      },
        data(){
            return{
                idVentaEncontrado:'',
                arrayDetalle: [],
                cliente:'',
                comprobante:'',
                numPedido:'',
                fechaPedido:'',
                idComprob:'',
                fecha:'',
                serieNumero:'',
                metodoPago:'',
                vendedor:'',
                ventactivo:'',
                subtotal:'',
                igv:'',
                moneda:'',
                idPedido:'',
                serie:'',
                numero:'',
                idUsuario:'',
                idSucursal:'',
                serieBuscar:'',
                numeroBuscar:'',

                arrayCodigoNC:[],
                tipoNota:0,
                motivo:'',
                errorGenerar:0,
                arrayMostMsjGenerar:[],
                idEmpresa:'',

                loading:false,
            }
        },
        computed:{
            id(){
                return this.$route.params.id
            }
        },
        methods:{
            buscarNC(){
                if(this.numeroBuscar=='' || this.serieBuscar==''){
                    this.$toastr.error('Ingrese la serie y el número del comprobante','Campos vacíos')
                    return
                }
                let me = this
                this.$axios.get(`apiventa/buscar-comprobante/?numero=${me.numeroBuscar}&serie=${me.serieBuscar.toUpperCase()}&idEmpresa=${me.idEmpresa}`)
                .then(function(response){
                    me.idVentaEncontrado = response.data.idVenta
                    me.listarVenta()
                    me.listarCodigNotaCre()
                })
                .catch(function(error){
                    if(error.response && error.response.status == 400){
                        me.$toastr.info('No se encontro comprobante','Sin registros')
                    }else{
                        me.$toastr.error('Error al buscar','Error')
                    }
                })
            },
            listarVenta(){
            let me = this
              this.$axios.get(`apiventa/ventas/${me.idVentaEncontrado}/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){console.log(response.data)
                  if(response.data){
                    me.cliente = response.data.cliente
                    me.idPedido = response.data.idPedido
                    me.comprobante = response.data.comprobanteobservacion
                    me.fechaPedido = response.data.fechaPedido
                    me.fecha = response.data.fecha
                    me.idComprob = response.data.tipComprobante
                    me.metodoPago = response.data.metodoPago
                    me.serieNumero = response.data.serie+'-'+response.data.numComprobante
                    me.serie = response.data.serie
                    me.numero = response.data.numComprobante
                    me.vendedor = response.data.vendedor
                    me.ventactivo = response.data.activo
                    //me.motivo = response.data.observacion
                    me.numPedido = response.data.numPedido
                    me.comprobante = response.data.comprobante
                    me.subtotal = response.data.subtotal
                    me.igv = response.data.igvTotal
                    me.moneda = response.data.moneda
                    me.listarDetalle()
                  }else{me.$toastr.info('No se encontraron datos','Sin registro');me.limpiar()}
              })
          },
          validarNota(){
            this.errorGenerar = 0
            this.arrayMostMsjGenerar = []
            if(!this.motivo.trim()) this.arrayMostMsjGenerar.push("Describa el motivo de la anulacion")
            if(!this.tipoNota) this.arrayMostMsjGenerar.push("Seleccione el tipo de nota de credito")
            if(this.arrayDetalle.length==0) this.arrayMostMsjGenerar.push("No se hallo comprobante a anular")
            if(this.ventactivo != 1) this.arrayMostMsjGenerar.push("Comprobante ya fue anulado")
            if(this.nombre_cdr === '') this.arrayMostMsjGenerar.push('Comprobante no fue Declarado a SUNAT')
            if(this.arrayMostMsjGenerar.length) this.errorGenerar = 1
            return this.errorGenerar
          },
          listarDetalle(){
            let me = this
            this.$axios.get(`apiventa/detalle/?idPedido=${me.idPedido}`)
              .then(function(response){
                  me.arrayDetalle = response.data
              })
          },
          listarCodigNotaCre(){
            let me = this
            this.$axios.get(`apisunat/codigonotacredito/`)
              .then(function(response){
                  me.arrayCodigoNC = response.data
              })
          },
          grabarNota(){
            if(this.validarNota()){
                this.arrayMostMsjGenerar.forEach(element => {
                this.$toastr.error(element,'Atencion!')
                });
                return
            }
            let me = this
            this.$swal.fire({
            title: 'Crear Nota de Crédito',
            text: "Esta seguro?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, crear'
            }).then((result) => {
                me.loading=true
                if (result.isConfirmed) {
                this.$axios.post(`apiventa/notacredito/?idEmpresa=${me.idEmpresa}`, { //URL GRABAR NOTA DE CREDITO
                    //subtotal: me.subtotal,
                    //igv: me.igv,
                    observacion: me.motivo.toUpperCase(),
                    idVenta: me.idVentaEncontrado,
                    idPedido: me.idPedido,
                    codigoNC: me.tipoNota,
                    //serieNumeroAnu: me.serieNumero,
                    serie: me.serie,
                    numComprobante: me.numero,
                    idSucursal:me.idSucursal,
                    idUsuario: me.idUsuario,
                    idEmpresa: me.idEmpresa,
                }).
                then((response)=>{
                    console.log(response.data)
                    me.$router.push('/notacredito')
                    me.$toastr.success('Nota de credito generado', 'Excelente!')
                }).
                catch((error)=>{
                    if (error.response && error.response.data) {
                        console.error("Mensaje del backend:", error.response.data.mensaje);  // <-- Aquí está lo que quieres
                        me.$toastr.error(error.response.data.mensaje || 'Error al generar NC', 'Error');
                    } else {
                        console.error("Error sin respuesta del backend:", error);
                        me.$toastr.error('Error desconocido', 'Error');
                    }
                })
                .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
                }
                else{
                    me.loading=false
                }
            })
          },
          formattedTotal(amount) {
            return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            }).format(amount);
          },
          limpiarTodo(){
            this.arrayDetalle= []
            this.comprobante=''
            this.serieNumero=''
            this.cliente=''
            this.idVentaEncontrado=''
            this.subtotal=0
            this.igv=0
            this.serieBuscar=''
            this.numeroBuscar=''
          }
        },
        mounted(){
            this.idUsuario = localStorage.getItem('idusuario')
            this.idSucursal = localStorage.getItem('idSucursal')
            this.idEmpresa = localStorage.getItem('idEmpresa')
        }
    }
</script>
<style>
    .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>